import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { navigationLayoutMode } from "../../store";
import ModernNavbar from "./ModernNavbar";
import SidebarNavbar from "./SidebarNavbar";

/**
 * NavbarSelector component that switches between horizontal and sidebar navigation
 * based on the user's layout preference stored in Recoil
 */
const NavbarSelector = () => {
  const navLayout = useRecoilValue(navigationLayoutMode);
  const setNavLayout = useSetRecoilState(navigationLayoutMode);
  const [isLgUp, setIsLgUp] = React.useState(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia("(min-width: 1024px)").matches;
  });

  React.useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const handleChange = (event) => setIsLgUp(event.matches);
    handleChange(media);
    if (media.addEventListener) {
      media.addEventListener("change", handleChange);
      return () => media.removeEventListener("change", handleChange);
    }
    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, []);

  React.useEffect(() => {
    if (!isLgUp && navLayout === "sidebar") {
      setNavLayout("horizontal");
    }
  }, [isLgUp, navLayout, setNavLayout]);

  if (navLayout === "sidebar" && isLgUp) {
    return <SidebarNavbar />;
  }

  return <ModernNavbar />;
};

export default NavbarSelector;
